/**
 * errors.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

export class ProtocolVersionError implements Error
{
  public readonly name : string = "ProtocolVersionError";
  public readonly message : string =
    `The application requested a feature not available in the agreed protocol`;

  constructor (public requiredVersion : number, public currentVersion : number)
  {
    /* */
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/types/errors.ts